export const testimonials = [
  {
    id: 1,
    company: 'Michael Thompson',
    identifier: 'Portland, OR',
    avatar: 'https://public.readdy.ai/ai/img_res/fcb3fac7ceb19391d7ddd495159df21f.jpg',
    review: 'DemoHub made the entire demolition process stress-free. They connected me with a licensed contractor who was professional, efficient, and completed my garage demolition ahead of schedule. Highly recommend!'
  },
  {
    id: 2,
    company: 'Jennifer Martinez',
    identifier: 'Seattle, WA',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20woman%20smiling%20confident%20friendly%20headshot%20portrait%20clean%20background%20natural%20lighting&width=80&height=80&seq=customer2&orientation=squarish',
    review: 'I needed to demolish an old commercial building and DemoHub connected me with the perfect contractor. The quote was transparent, the work was excellent, and cleanup was thorough. Five stars!'
  },
  {
    id: 3,
    company: 'David Chen',
    identifier: 'San Francisco, CA',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20man%20smiling%20friendly%20headshot%20portrait%20clean%20background%20natural%20lighting&width=80&height=80&seq=customer3&orientation=squarish',
    review: 'Outstanding service from start to finish. The demolition team was punctual, safety-conscious, and completed my residential demolition project perfectly. The pricing was fair and there were no surprises.'
  },
  {
    id: 4,
    company: 'Sarah Williams',
    identifier: 'Los Angeles, CA',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20woman%20with%20blonde%20hair%20smiling%20friendly%20headshot%20portrait%20clean%20background%20natural%20lighting&width=80&height=80&seq=customer4&orientation=squarish',
    review: 'DemoHub took all the guesswork out of finding a reliable demolition contractor. The platform is easy to use, and I received multiple competitive quotes within hours. The contractor they matched me with was fantastic!'
  },
  {
    id: 5,
    company: 'Robert Johnson',
    identifier: 'Denver, CO',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20older%20man%20smiling%20friendly%20face%20headshot%20portrait%20clean%20background%20natural%20lighting&width=80&height=80&seq=customer5&orientation=squarish',
    review: 'I was impressed by how quickly DemoHub connected me with qualified contractors. The demolition of my old shed was handled professionally, and the site was left clean. Great experience overall!'
  },
  {
    id: 6,
    company: 'Amanda Rodriguez',
    identifier: 'Phoenix, AZ',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20hispanic%20woman%20smiling%20friendly%20headshot%20portrait%20clean%20background%20natural%20lighting&width=80&height=80&seq=customer6&orientation=squarish',
    review: 'Excellent platform! DemoHub made it simple to get quotes and choose the right contractor for my commercial demolition project. Communication was clear, and the results exceeded my expectations.'
  }
];